<script>

    import { createEventDispatcher } from 'svelte';
    import { UID } from '@repo/config/Utils';
    import CheckBox from '#form/CheckBox.svelte';
    /**
     * @typedef {Object} Props
     * @property {any} action
     * @property {any} label
     * @property {boolean} [checked]
     * @property {boolean} [noAriaRole]
     * @property {any} [role]
     * @property {any} [disabled]
     * @property {any} [name]
     */
    let {
        action,
        label,
        checked = $bindable(false),
        noAriaRole = false,
        role = null,
        disabled = null,
        name = null
    } = $props();

    const id = 'cb_lb_' + UID();

    const dispatch = createEventDispatcher();

    function handleMenuItemClick(e) {
        if (disabled) return;

        checked = !checked;
        dispatch('click', {id: action, state: checked, label});
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            // Stop the parent FloatingMenu's keydown handler from also
            // triggering a click, which would toggle the checkbox twice
            e.preventDefault();
            e.stopPropagation();
            handleMenuItemClick(e);
        }
    }
    
</script>

<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<li class="floating-menu-row interactive" 
    onclick={handleMenuItemClick}
    onkeydown={handleKeyDown}
    role={noAriaRole ? null : (role ?? 'menuitemcheckbox')}
    aria-label={label}  
    tabindex="0"
    {...(role === 'option' ? { 'aria-checked': checked ? 'true' : 'false' } : {})}
    id={id}
    >
    <CheckBox onchange={handleMenuItemClick} name={name || label} {label} value={checked ? 'checked' : 'unchecked'} disabled={disabled} />
</li>

<style>
    .floating-menu-row{
        display:flex;
        flex-direction:row;
        align-items:center;
        justify-content:flex-start;
        flex-shrink:0;
        max-width:20rem;
        color:#eee;
    }

    .floating-menu-row:focus-visible{
        background-color:rgb(170, 170, 170);
        outline: 2px solid black;   
        z-index: 1;
        color: #000;
    }

    .floating-menu-row:hover{
        background-color:rgba(0,0,0,0.3);
    }       

    .floating-menu-row i{
        margin:0.75rem;
        color:inherit;
        
    }

    .floating-menu-row span{
        margin:0.75rem 1.5rem 0.75rem 0;
        color:inherit;
        text-wrap: wrap;
    }

    

</style>